/* eslint-disable no-unused-vars */
/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/control-has-associated-label */
import * as React from "react";

interface TCustomSelectProps {
  options: { value: any; label: string }[];
  className: string;
  handleChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  text?: {
    value: string;
    label: string;
  };
  value: string;
  classSelect?: string;
}
export default function CustomSelect({
  options,
  className,
  handleChange,
  text,
  value,
  classSelect = ""
}: TCustomSelectProps) {
  return (
    <div>
      <form className={className}>
        <select
          onChange={handleChange}
          className={
            classSelect ||
            "px-1 m-0 h-10 text-[15px] text-start rounded-md border border-gray w-full outline-none cursor-pointer"
          }
          value={value}
        >
          {text && <option value={text.value}>{text.label}</option>}
          {options?.map((item, index) => (
            <option
              key={index}
              value={item.value}
              className="text-ellipsis line-clamp-1 w-full py-2"
              style={{
                color: "black"
              }}
            >
              {item.label}
            </option>
          ))}
        </select>
      </form>
    </div>
  );
}
